import type { ReactNode } from 'react';
import { Btn } from '@l2u/ui/components/Btn.tsx';
import { Modal } from '@l2u/ui/components/Modal.tsx';

type Props = {
  open: boolean;
  title: string;
  /** Question + any supporting copy (and inline errors) rendered in the body. */
  children: ReactNode;
  confirmLabel: string;
  /** Renders the confirm button in the red danger variant. */
  danger?: boolean;
  loading?: boolean;
  /** Render above other open modals (stacked confirmation). */
  elevated?: boolean;
  onConfirm: () => void;
  onClose: () => void;
};

/**
 * Small confirmation dialog built on Modal: a question, a Cancel button and a
 * single confirm action. Used by the company deactivate/reactivate flows.
 */
export function ConfirmModal({
  open,
  title,
  children,
  confirmLabel,
  danger = false,
  loading = false,
  elevated = false,
  onConfirm,
  onClose,
}: Props) {
  return (
    <Modal
      open={open}
      onClose={onClose}
      title={title}
      size="sm"
      elevated={elevated}
      footer={
        <>
          <Btn variant="ghost" onClick={onClose}>
            Cancel
          </Btn>
          <Btn variant={danger ? 'danger' : 'primary'} onClick={onConfirm} loading={loading}>
            {confirmLabel}
          </Btn>
        </>
      }
    >
      <div className="text-sm text-slate-700">{children}</div>
    </Modal>
  );
}
